import { graphql } from 'gatsby';

import GlobalHead from '../../layout/head';

import layoutTheme from '../../editorial/theme';
import Layout from '../../layout';
import CategoryArchiveLayout from './layout';

import type { HeadProps, PageProps } from 'gatsby';
import type { ICategory, IPageContext } from './types';

const CategoryArchiveTemplate = ({ data, pageContext, ...pageProps }: PageProps<ICategory, IPageContext>) => (
  <Layout
    {...pageProps}
    {...pageContext}
    showBreadcrumbs={false}
    templateName="Editorial"
    theme={layoutTheme}
  >
    <CategoryArchiveLayout data={data} pageContext={pageContext} />
  </Layout>
);

export const query = graphql`
  query CategoryArchiveTemplate($id: String!, $name: String!, $skip: Int!, $limit: Int!) {
    wpCategory(id: {eq: $id}) {
      name
      description
      categoryOptions {
        featuredImage {
          altText
          gatsbyImage: wpGatsbyImage(width: 588, height: 392)
        }
        testimonial {
          buttons {
            url
            text
            openInNewTab
          }
          quoteText
        }
      }
      headlessSeo {
        canonical
        metaDesc
        metaRobotsNoindex
        metaRobotsNofollow
        title
      }
      translations {
        hreflang
        url
      }
    }
    allWpPost(
      skip: $skip
      limit: $limit
      sort: {date: DESC}
      filter: {categories: {nodes: {elemMatch: {name: {eq: $name}}}}}
    ) {
      nodes {
        ...BlogCardPost
      }
    }
    featuredPosts: allWpPost(
      limit: 3
      sort: {date: DESC}
      filter: {
        templatesEditorial: {featuredPost: {isFeatured: {eq: true}}},
        categories: {nodes: {elemMatch: {name: {eq: $name}}}}
      }
    ) {
      nodes {
        ...BlogCardPost
      }
    }
  }
`;

export const Head = ({
  data,
  location,
  pageContext,
}: HeadProps<ICategory, IPageContext>) => (
  <GlobalHead
    forceCanonicalTag={true}
    isPaginated={(pageContext && pageContext?.numberOfPages > 0)}
    pathname={location.pathname}
    seo={{
      title: data?.wpCategory?.headlessSeo?.title || `Posts about ${data?.wpCategory?.name} | Klaviyo`,
      canonical: data?.wpCategory?.headlessSeo?.canonical + (pageContext?.pageNumber > 0 ? `/${pageContext.pageNumber + 1}/` : ''),
      metaDesc: data?.wpCategory?.headlessSeo?.metaDesc,
      metaRobotsNofollow: data?.wpCategory?.headlessSeo?.metaRobotsNofollow || 'follow',
      metaRobotsNoindex: data?.wpCategory?.headlessSeo?.metaRobotsNoindex || 'index',
      prevPagePath: (pageContext?.previousPagePath ? pageContext?.previousPagePath : ''),
      nextPagePath: (pageContext?.nextPagePath ? pageContext?.nextPagePath : ''),
    }}
    translations={data?.wpCategory?.translations}
  />
);

export default CategoryArchiveTemplate;
